import KeyLine from 'components/shared/KeyLine';
import { KeyLinePosition } from 'types/constants';
import { cn } from 'utils/styles';
import { CalloutGridVariants } from 'components/CalloutGrid/CalloutGrid';

/**
 * Props for the CalloutGridCardKeyline component
 */
interface CalloutGridCardKeylineProps {
  keyline?: KeyLinePosition;
  variant: CalloutGridVariants;
}

/**
 * Renders a keyline for a CalloutGrid card
 * Handles visibility logic based on keyline position and variant
 */
const CalloutGridCardKeyline = ({ keyline, variant }: CalloutGridCardKeylineProps) => {
  const isBasicVariant = variant === CalloutGridVariants.Basic;
  const isImageVariant = variant === CalloutGridVariants.Image;

  const keylineClasses = cn(
    keyline === KeyLinePosition.Top ? 'sm:block' : 'sm:hidden',
    isBasicVariant && keyline === KeyLinePosition.Between ? 'block mb-6' : 'hidden',
    isImageVariant && 'hidden sm:hidden', // Keyline is not supported for Image variants
  );

  return (
    <div className={cn('keyline', keylineClasses)}>
      <KeyLine />
    </div>
  );
};

export default CalloutGridCardKeyline;
